import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from "react";

const Accordion = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const data = [
        {
            title: "Who is Beyondtech?",
            content:
                "Beyondtech is a financial technology company in Indonesia that provides money transfer-based financial solutions. Beyond simply offering financial services, Beyondtech is driven by a greater purpose—to continuously grow and assist both individuals and businesses in achieving their financial goals and aspirations through innovation and technology.",
        },
        {
            title: "What are financial services covered by Beyondtech?",
            content:
                "Beyondtech is the solution for those who strive for progress. We simplify the achievement of your financial goals through innovative products such as Payment Link, Disbursement, and Remittance.",
        },
        {
            title: "What are advantages of Beyondtech?",
            content: [
                "Multiple Payment Methods – Access 20+ payment options, including e-Wallets, Bank Transfers, Payment Links, and Credit/Debit Cards. ",
                "Efficiency Through Automation – Enjoy automated payments via API, payment verification, and real-time financial reporting. ",
                "Risk Management & Security – Equipped with licensed security systems that comply with world-class regulatory standards. ",
                "24/7 Expert Support – Our team is available around the clock to assist with your needs, even in the middle of the night. ",
                "Seamless Integration – Flexible plugin and API solutions tailored for various platforms, ensuring a smooth integration process. ",
                "No Registration Fees – Transparent pricing model with charges applied only on successful transactions.",
            ],
        },
        {
            title: "What is Payment Link?",
            content:
                "A Payment Link is a payment acceptance link that enables seamless and instant transactions, providing a convenient and efficient way for users to make payments effortlessly.",
        },
        {
            title: "How does Payment Link works?",
            content:
                "Simply generate a Payment Link and share it with your customers via WhatsApp, SMS, Email, Social Media, and various other platforms, making transactions seamless and hassle-free.",
        },
        {
            title: "What are the benefits of Payment Link?",
            content:
                "You can accept payments effortlessly with a single link—no coding required.",
        },
        {
            title: "What payment method uses Payment Link?",
            content:
                "The Payment Link accepts payments through Credit/Debit Cards, Virtual Accounts, E-Wallets, and Direct Debit, providing a seamless and flexible payment experience.",
        },
        {
            title: "How long does it take to do Payment Link?",
            content:
                "The Payment Link enables real-time transactions—once your customer completes the payment, you will instantly receive a payment notification, ensuring a seamless and efficient payment process.",
        },
        {
            title: "Will there be time outs for the link?",
            content:
                "The Payment Link allows you to set and customize transaction time limits according to your specific needs, ensuring greater control and flexibility over your payment process.",
        },
        {
            title: "Does it support API-integration for multiple link creation?",
            content:
                "We provide API integration for generating Payment Links in bulk and sending them automatically, eliminating the need for manual copy-pasting and streamlining your payment process.",
        },
        {
            title: "What is Disbursement?",
            content:
                "Disbursement is a feature that enables fund transfers to multiple destinations, optimizing your business operations efficiently. With same-day processing, it eliminates complexity, allowing you to focus on growth and success.",
        },
        {
            title: "How does Disbursement work?",
            content:
                "Disbursement allows you to send funds to multiple destinations with just a single confirmation. You can perform bulk transfers or single transfers, streamlining your financial transactions efficiently.",
        },
        {
            title: "Is the cost transparent to do Disbursement?",
            content:
                "Disbursement is a real-time process and there is no hidden fees in the service.",
        },
        {
            title: "What is Remittance?",
            content:
                "Remittance is a money transfer platform that is integrated with all banks connected to principals or bank switching partners, ensuring seamless and secure fund transfers.",
        },
        {
            title: "What are the benefits of Remittance?",
            content:
                "Our Remittance service offers the easiest, safest, and most convenient way to transfer funds from Indonesia to over 200 countries, ensuring secure and hassle-free international transactions.",
        },
        {
            title: "What countries are covered in the Remittance service?",
            content:
                "Our Remittance service supports fund transfers from Indonesia to over 200 countries, providing a seamless and reliable global payment solution.",
        },
        {
            title: "How long does it take to do Remittance?",
            content:
                "Remittance enables real-time transactions—once your customer completes the transfer, you will instantly receive a transfer notification, ensuring a smooth and efficient money transfer process.",
        },
        {
            title: "Is Remittance secure?",
            content:
                "In addition to offering highly competitive exchange rates and fees, ensuring stability and minimizing transaction risks, our Remittance service is fully secured and licensed by Bank Indonesia, guaranteeing compliance and reliability.",
        },
        {
            title: "Is Remittance service available online? Do I have to walk to nearest branch to have the service?",
            content:
                "International money transfers via Remittance are 100% online! From registration and account verification to fund transfers, everything can be done seamlessly from the comfort of your seat.",
        },
        {
            title: "Can we cancel transmission in progress?",
            content:
                "Transactions cannot be canceled once the payment process has been completed. Please ensure that all fund transfer details, including the destination country information, are accurate before proceeding with the transaction.",
        },
        {
            title: "Is there a transaction notification available?",
            content:
                "You can easily track your transactions. Once the transaction is completed, the funds will be delivered to the recipient’s bank, and you will receive a transaction notification for confirmation.",
        },
        {
            title: "How long does transaction usually take to complete?",
            content:
                "The estimated transaction processing time varies depending on the destination currency, with completion expected within minutes or on the same business day. For further details, please contact our Customer Support team.",
        },
    ];

    // Set the color order
    const colors = ["#F3F7FF", "#FDF8F1", "#FFF5F5"];

    // Add the background color (bgColor) in a cyclic manner
    const dataWithBgColor = data.map((item, index) => ({
        ...item,
        bgColor: colors[index % colors.length], // Use modulo to repeat the color cycle
    }));

    // Filter data based on search term
    const filteredData = dataWithBgColor.filter((item) =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
          AOS.init({ once: true });
        }, []);

    return (
        <div className="space-y-4" data-aos="fade-right" data-aos-duration="1500">
            {/* Search Input */}
            <input
                type="text"
                placeholder="Search ..."
                className=" relative w-full p-2 border border-gray-300 rounded-xl mb-4"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />

            {filteredData.map((item, index) => (
                <div
                    key={index}
                    className={`rounded-lg bg-red-500 p-5 ${activeIndex === index ? "space-y-3" : "space-y-1"
                        }`}
                    style={{
                        backgroundColor: item.bgColor,
                    }}
                >
                    <div
                        className="font-bold text-[#505050] cursor-pointer flex justify-between items-center"
                        onClick={() => toggleAccordion(index)}
                        role="button"
                    >
                        <span className="p-2 pr-2 md:pr-5">{item.title}</span>
                        <FontAwesomeIcon
                            icon={faChevronDown}
                            className={`transition-transform duration-500 ${activeIndex === index ? "rotate-180" : ""}`}
                            style={{ pointerEvents: "auto" }}
                        />
                    </div>
                    <div
                        className={`overflow-hidden transition-all ease-in-out`}
                        style={{
                            maxHeight: activeIndex === index ? "max-content" : "0",
                            transition: "max-height 0.3s ease",
                        }}
                    >
                        <p className="text-[#505050] text-[14px] md:text-base mt-2 text-justify">{item.content}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Accordion;
